export interface MeliOrderBuyerInfo {
  id: number;
  nickname?: string | null;
  last_name?: string | null;
  first_name?: string | null;
  billing_info?: { id: string };
}

export interface MeliOrderApi {
  orderId: number;
  externalId: number;
  sellerId: number;
  packId?: number;
  negocio: string;
  meliStatus: string;
  sdStatus?: string;
  allowGetLabel: boolean;
  labelObtained: boolean;
  labelPath?: string | null;
  buyerInfo?: MeliOrderBuyerInfo | null;
  dateCreated: string;
  lastUpdated: string;
  deliveryDate?: string | null;
  routeDate?: string | null;
  driverName?: string | null;
  driverPhone?: string | null;
  logisticCompany?: string;
  commerceName?: string;
  businessCommerceCode?: string;
  businessCommerceName?: string;
  businessShippingNumber?: string | null;
}

export interface MeliOrdersResponse {
  total: number;
  limit: number;
  offset: number;
  orders: MeliOrderApi[];
  lastBusinessSyncAt?: string | null;
}

export interface SellerApi {
  id: number;
  userNickName: string;
}

export interface MeliCommerceOption {
  code: string;
  name: string;
}

/** Fechas en YYYY-MM-DD, día calendario del país. */
export interface MeliOrdersFilter {
  orderId?: string;
  businessShippingNumber?: string;
  externalId?: string;
  buyerName?: string;
  commerceCode?: string;
  commerceName?: string;
  driverName?: string;
  sdStatus?: string;
  meliStatus?: string;
  dateFrom?: string;
  dateTo?: string;
  deliveryDateFrom?: string;
  deliveryDateTo?: string;
}

export type MeliOrdersSortField = 'dateCreated' | 'lastUpdated' | 'deliveryDate';

export interface MeliOrdersSort {
  field: MeliOrdersSortField;
  direction: 'asc' | 'desc';
}

export interface MeliOrdersQuery {
  filter: MeliOrdersFilter;
  sort: MeliOrdersSort;
  page: number;
  pageSize: number;
}

export const hasMeliOrderIdentifier = (filter: MeliOrdersFilter): boolean =>
  Boolean(filter.orderId?.trim() || filter.externalId?.trim() || filter.businessShippingNumber?.trim());
